import React from "react"
import Paper from "../boxes/Paper"
import DescriptionBox from "../boxes/DescriptionBox"

const LoanSidePane = (): JSX.Element => {
  return (
    <aside className="flex-col-2 u-min-w-360 u-ml-20 d-none d-lg-block">
      <Paper className="u-mt-40" grey>
        <DescriptionBox
          className="mz-new-loan-aside__verification"
          i18nText="loan.aside.verification.text"
          i18nTitle="loan.aside.verification.title"
        />
        <DescriptionBox
          className="mz-new-loan-aside__audit"
          i18nText="loan.aside.audit.text"
          i18nTitle="loan.aside.audit.title"
        />
        <DescriptionBox
          className="mz-new-loan-aside__transparency"
          i18nText="loan.aside.transparency.text"
          i18nTitle="loan.aside.transparency.title"
        />
      </Paper>
    </aside>
  )
}

export default LoanSidePane
